import * as React from 'react';
import * as moment from "moment";
import {connect} from "react-redux";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import * as styles from './style.css';
import StickersComponentsMediaPhoto from "../../components/media-photo";

import StickersComponentsMediaAudio from "../../components/media-audio";
import StickersComponentsMediaVideo from "../../components/media-video";
import UQButton from "../../../../uq-ui/components/button";
import {currentUserInfoSelector} from "../../../../auth/store/auth-user/selectors";
import {mediaAudioStateSelector} from "../../../store/media-audio/selectors";
import {mediaPhotoStateSelector} from "../../../store/media-photo/selectors";
import {mediaVideoStateSelector} from "../../../store/media-video/selectors";
import {
  createLlamaActiveThemeSelector,
  createLlamaFormSelector,
  createLlamaShowThemeSelector,
  createLlamaStateSelector, createLlamaTypeSelector, createStickerIdSelector, createStickerItemIdSelector
} from "../../../store/create-llama/selectors";
import {StickerFormatEnum} from "../../../domain/enums/StickerFormatEnum";
import {checkStepValidation, saveSticker} from "../../../store/create-llama/actions";
import {StickerCreateStepEnum} from "../../../domain/enums/StickerCreateStepEnum";
import Div100vh from "../../../../uq-ui/components/div-100";
import ConfirmModal from "../../../../uq-ui/components/confirm-modal";
import {getTextDirection} from "../../../../uq-ui/helpers/messageDirection";
import TextWithLinks from '../../../../uq-ui/components/text-with-links';
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import Icon from "../../../../icons/Icon";
import ThemesScrollbar from "../../../../layout/ui/components/themed-scrollbar";
import classNames from "classnames";
import linearTranslation from "../../../../../utils/linear-translation";
import {withWindowSizeListener} from 'react-window-size-listener';
import {withTypeTranslation} from "../../../../../i18n";
import { isMemorialType } from "../../../store/sticker-show/selectors";
class StickersScreensPreview extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
    };
  }

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-preview');
    this.props.checkStepValidation(StickerCreateStepEnum.Preview);
  }

  onBackPressed = () => {
    const {stickerState, history, stickerId, stickerItemId} = this.props;
    const basePath = `/stickers/${stickerId}`
    switch (stickerState.form.format) {
      case StickerFormatEnum.Image:
        history.push(`${basePath}/new/photo`);
        break;
      case StickerFormatEnum.Audio:
        history.push(`${basePath}/new/audio`);
        break;
      case StickerFormatEnum.Video:
        history.push(`${basePath}/new/video`);
        break;
    }
  };

  onFinishPressed = () => {
    this.setState({showConfirmModal: true});
  };

  onConfirmPressed = () => {
    this.setState({showConfirmModal: false});
    this.props.saveSticker();
  };

  onEditThemePressed = () => {
    const {history, stickerId, stickerItemId} = this.props;
    history.push(`/stickers/${stickerId}/new/theme`);

  };

  onEditMessagePressed = () => {
    const {history, stickerId, stickerItemId} = this.props;
    history.push(`/stickers/${stickerId}/new/message`);

  };

  onModalClosePressed = () => {
    this.setState({showConfirmModal: false});
  };

  renderDate() {
    return (<div className={ this.props.isMemorialTheme ? styles.dateString_memorial : styles.dateString }>{this.getDateString()}</div>);
  }

  renderAuthor() {
    return (<div className={ this.props.isMemorialTheme ? styles.author_memorial : styles.author }>{this.getAuthorString()}</div>)
  }

  getAuthorString() {
    return this.props.currentUserInfo.display_name || '';
  }

  getDateString() {
    return moment().format('MMM YYYY');
  }

  renderGreeting(greeting_text) {
    const value = linearTranslation(window.innerHeight, 550, 80, 750, 160);
    let maxHeight = `${value}px`;
    const hasLinks = greeting_text.search(/https/ig) === -1;
    return (
      <ThemesScrollbar maxHeight={maxHeight}>
        {hasLinks ?
          greeting_text
          :
          <TextWithLinks linkStyle={{color: '#495BFF', textDecorationLine: 'underline', cursor: 'default'}}
                         text={greeting_text}/>
        }
      </ThemesScrollbar>
    );
  }

  renderEditIcon = (callback) => {
    return (
      <UQButton
        label={''}
        onPress={callback}
        containerClass={styles.themeEditContainer}
        theme={ this.props.isMemorialTheme ? 'memorial' : 'brand'}
        justIcon={true}
        icon={<Icon name={ this.props.isMemorialTheme ? 'EditPencilDark' : 'EditPencil' } width={"15px"} height={"15px"}/>}
      />
    );
  };


  renderTextContent() {
    const {greeting_text} = this.props.stickerData;
    const placeholderText = this.props.t2(this.props.stickerType, 'textPlaceholder');
    const displayText = greeting_text || placeholderText;
    const direction = getTextDirection(displayText);
    const greetingTextClasses = classNames({
      [ this.props.isMemorialTheme ? styles.stickerText_memorial : styles.stickerText]: true,
      [styles.stickerTextPlaceholder]: !greeting_text
    });
    return (
      <div>
        <div style={{position: "relative", zIndex: 2}}>
          {this.renderEditIcon(this.onEditMessagePressed)}

          <div className={greetingTextClasses} style={{direction}} onClick={this.onEditMessagePressed}>
            {this.renderGreeting(displayText)}
          </div>

        </div>
        <div className={styles.authorDateContainer}>
          <div className={styles.authorDateInner}>
            {this.getAuthorString() && this.renderAuthor()}
            {this.renderDate()}
          </div>
        </div>
      </div>
    );
  }


  renderTheme() {
    if (!this.props.showTheme) {
      return null;
    }

    const theme = this.props.selectedTheme;
    const value = linearTranslation(window.innerHeight, 550, 10, 800, 0);
    const bottom = `${value}vh`;
    if (theme) {
      return (
        <div className={styles.themeWrap} style={{
          backgroundImage: `url(${theme.show.source.srcSvg})`,
          backgroundPosition: `0 ${bottom}` // cutting image to maintain non scrollable screen
        }} onClick={this.onEditThemePressed}>
          {this.renderEditIcon(this.onEditThemePressed)}
        </div>
      )
    }
    return null;
  }

  renderStickerMedia() {
    switch (this.props.stickerData.format) {
      case StickerFormatEnum.Image:
        const imageSource = this.props.mediaPhotoState.resultPhotoPath;
        return (<StickersComponentsMediaPhoto source={imageSource} isMemorial={ this.props.isMemorialTheme } />);
      case StickerFormatEnum.Audio:
        const audioSource = this.props.mediaAudioState.originAudioPath;
        const audioDuration = this.props.mediaAudioState.currentDuration;
        if (audioDuration != null && audioSource != null) {
          return (
            <StickersComponentsMediaAudio
              source={audioSource}
              duration={audioDuration}/>
          );
        }
        return null;
      // case StickerFormatEnum.Audio:
      //   const audioSource = this.props.mediaAudioState.originAudioPath;
      //   const audioDuration = this.props.mediaAudioState.currentDuration;
      //   if (audioDuration != null && audioSource != null) {
      //     return (
      //       <StickersComponentsMediaAudio
      //         source={audioSource}
      //         duration={audioDuration}/>
      //     );
      //   }
      //   return null;
      case StickerFormatEnum.Video:
        const videoSource = this.props.mediaVideoState.originVideoPath;
        const videoDuration = this.props.mediaVideoState.duration;
        const videoThumbnail = this.props.mediaVideoState.resultPreviewPath;
        return (<StickersComponentsMediaVideo
          duration={videoDuration}
          thumbnail={videoThumbnail}
          source={videoSource}/>);
      default:
        return null;
    }
  }

  render() {
    return (
      <Div100vh 
        className={ this.props.isMemorialTheme ? styles.sticker_memorial : styles.sticker } 
        style={{minHeight: '100rvh', overflow: 'hidden'}} 
        withResize={false}
      >
        <button type="button"
                onClick={this.onBackPressed}
                className={ this.props.isMemorialTheme ? styles.backButton_memorial : styles.backButton }>
          <Icon name={ this.props.isMemorialTheme ? 'HeaderBackDarkBlue' : 'HeaderBackDark' } style={{width: "30px"}}/>
        </button>
        <div style={{position: 'relative'}} className={"font-text"}>
          <div className={styles.stickerMediaContainer}>
            {this.renderStickerMedia()}
          </div>
          {this.renderTextContent()}
        </div>
        {this.renderTheme()}
        <div className={styles.bottom}>
          <UQButton label={this.props.t('finishBtn')}
                    containerStyle={{minWidth: 140}}
                    theme={ this.props.isMemorialTheme ? 'memorial' : 'brand' }
                    onPress={this.onFinishPressed}/>
        </div>
        <ConfirmModal show={this.state.showConfirmModal}
                      title={this.props.t('sureTitle')}
                      confirmLabel={this.props.t('sureConfirm')}
                      onClose={this.onModalClosePressed}
                      onConfirm={this.onConfirmPressed}
                      isMemorialTheme={ this.props.isMemorialTheme }>
          {this.props.t('sureDesc')}
        </ConfirmModal>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    currentUserInfo: currentUserInfoSelector(state),
    mediaAudioState: mediaAudioStateSelector(state),
    mediaPhotoState: mediaPhotoStateSelector(state),
    mediaVideoState: mediaVideoStateSelector(state),
    stickerData: createLlamaFormSelector(state),
    showTheme: createLlamaShowThemeSelector(state),
    stickerType: createLlamaTypeSelector(state),
    selectedTheme: createLlamaActiveThemeSelector(state),
    stickerState: createLlamaStateSelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveSticker: () => dispatch(saveSticker()),
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum)),
  }
};

export default compose(
  withTranslation('scr-new-sticker-preview'),
  connect(mapStateToProps, mapDispatchToProps),
  withTypeTranslation
)(withWindowSizeListener(StickersScreensPreview));



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/preview/index.jsx